import axiosInstance from "./axiosInstance";

type FormPostUpdateProps = {
  message?: string;
  imagePost?: File[];
  imageURLs?: string[];
};

const updatePost = async (postId: number, formPost: FormPostUpdateProps) => {
  const accessToken = localStorage.getItem("accessTokenGC");

  const formData = new FormData();

  if (formPost.message) {
    formData.append("message", formPost.message);
  }
  if (formPost.imagePost && Array.isArray(formPost.imagePost)) {
    formPost.imagePost.forEach((file: File) => {
      formData.append("imagePost", file);
    });
  }

  if (formPost.imageURLs && Array.isArray(formPost.imageURLs)) {
    formData.append("imageURLs", JSON.stringify(formPost.imageURLs));
  }

  try {
    const response = await axiosInstance.patch(
      `/api/post/${postId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error("Error updating post");
  }
};

export default updatePost;
